module.exports = __webpack_public_path__ + "img/type10110.c8328300.png";